// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1zvo6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__x5Jcy"};